import type { ChoosableSubscriptionFrequency, ChoosableSubscriptionFrequencyGroup } from 'autogen/swagger/all';
import type { IOption } from 'components/shared/inputs/select';

const shortListLength = 5;

function getFrequencyFromId(frequencies: ChoosableSubscriptionFrequency[], id: string): ChoosableSubscriptionFrequency {
    const frequencyObj = frequencies.find(
        (frequency) => frequency.id.toString() === id
    ) as ChoosableSubscriptionFrequency;

    return frequencyObj;
}

function mapOptionData(frequency: ChoosableSubscriptionFrequency): IOption {
    const { nameWithRecommendationText, id } = frequency;
    const optionItem: IOption = {
        label: nameWithRecommendationText,
        value: id.toString()
    };

    return optionItem;
}

function mapOptionsData(frequencies: ChoosableSubscriptionFrequency[]): IOption[] {
    const optionsArray: IOption[] = [];

    frequencies.forEach((frequency) => {
        const optionItem = mapOptionData(frequency);

        optionsArray.push(optionItem);
    });

    return optionsArray;
}

function getRecommendedGroup(choosable: ChoosableSubscriptionFrequencyGroup[]): ChoosableSubscriptionFrequencyGroup {
    const recommendedGroup = choosable.find((item) => item.isRecommended) || choosable[0];

    return recommendedGroup;
}

function getSelectedGroup(choosable: ChoosableSubscriptionFrequencyGroup[]): ChoosableSubscriptionFrequencyGroup {
    const selectedGroup = choosable.find((item) => item.isSelected);

    return selectedGroup || getRecommendedGroup(choosable);
}

function getRecommendedItem(frequencies: ChoosableSubscriptionFrequency[]): ChoosableSubscriptionFrequency {
    const recommendedItem = frequencies.find((item) => item.isRecommended) || frequencies[0];

    return recommendedItem;
}

function getSelectedItem(frequencies: ChoosableSubscriptionFrequency[]): ChoosableSubscriptionFrequency {
    const selectedItem = frequencies.find((item) => item.isSelected);

    return selectedItem || getRecommendedItem(frequencies);
}

function getShortListOptions(frequencies: ChoosableSubscriptionFrequency[]): ChoosableSubscriptionFrequency[] {
    const recommendedItem = getRecommendedItem(frequencies);
    const recommendedItemIndex = frequencies.indexOf(recommendedItem);
    const beforeIndexQuantity = Math.floor(shortListLength / 2);
    const afterIndexQuantity = Math.round(shortListLength / 2);

    const shortListOptions = frequencies.slice(
        Math.max(0, recommendedItemIndex - beforeIndexQuantity),
        Math.min(recommendedItemIndex + afterIndexQuantity, frequencies.length)
    );

    return shortListOptions;
}

export {
    getFrequencyFromId,
    mapOptionData,
    mapOptionsData,
    getSelectedItem,
    getSelectedGroup,
    getRecommendedGroup,
    getRecommendedItem,
    getShortListOptions
};
